// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__31Noo","label":"Section_label__1mXDG","contentWrap":"Section_contentWrap__FXWn9","footer":"Section_footer__vT6xa","footerInner":"Section_footerInner__3n09x"};